<template>
  <div
    class="image-onboarding-pretest-container d-flex"
    :class="{
      'diff-position-images': sizeImages.width === SIZE_FOR_MOBILE,
      'diff-position-images-se': sizeImages.width === SIZE_FOR_SE_MOBILE,
    }"
  >
    <FirstStepPretestComponent
      v-show="currentStepIndex === enumSteps.FIRST"
      :size="sizeImages"
    />
    <h3
      v-show="sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex == enumSteps.FIRST"
      class="heading primary--text heading-m-small onboarding-title-regular-mobile pr-6 text-center"
    >
      {{ titleForMobileSE }}
    </h3>
    <SecondStepPretestComponent
      v-show="currentStepIndex === enumSteps.SECOND"
      :size="sizeImages"
    />
    <h3
      v-show="sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex == enumSteps.SECOND"
      class="heading primary--text heading-m-small onboarding-title-regular-mobile pl-2 pr-3 text-left"
    >
      {{ titleForMobileSE }}
    </h3>
    <ResultStepPretestComponent
      v-show="currentStepIndex === enumSteps.THIRD"
      :size="sizeImages"
    />
    <h3
      v-show="sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex === enumSteps.THIRD"
      class="heading primary--text heading-m-small onboarding-title-regular-mobile pl-2 pr-3 text-left"
    >
      {{ titleForMobileSE }}
    </h3>
  </div>
</template>
<script>
export default {
  components: {
    FirstStepPretestComponent: () => import('./FirstStepPretestComponent.vue'),
    SecondStepPretestComponent: () => import('./SecondStepPretestComponent.vue'),
    ResultStepPretestComponent: () => import('./ResultStepPretestComponent.vue'),
  },
  props: ['currentStepIndex', 'items'],
  data: () => ({
    enumSteps: { FIRST: 0, SECOND: 1, THIRD: 2 },
    SIZE_FOR_MOBILE: 346,
    SIZE_FOR_SE_MOBILE: 127,
    SIZE_FOR_TABLETS_AND_UP: 188,
  }),
  computed: {
    titleForMobileSE() {
      return this.items[this.currentStepIndex].title;
    },
    sizeImages() {
      if (this.$breakpoint.mobileOnly) {
        return { width: this.SIZE_FOR_MOBILE, height: this.SIZE_FOR_MOBILE };
      }

      if (this.$breakpoint.smallMobile) {
        return { width: this.SIZE_FOR_SE_MOBILE, height: this.SIZE_FOR_SE_MOBILE };
      }

      return { width: this.SIZE_FOR_TABLETS_AND_UP, height: this.SIZE_FOR_TABLETS_AND_UP };
    },
  },
};
</script>

<style scoped>
.diff-position-images {
  margin-left: 0px;
  margin-top: 0px;
}
.diff-position-images-se {
  margin-top: 54px;
}

@media (max-width: 375px) {
  .image-onboarding-pretest-container {
    padding-bottom: 32px;
  }
}

@media (max-width: 320px) {
  .onboarding-title-regular-mobile {
    flex: 50%;
  }

  .image-onboarding-pretest-container {
    height: 188px;
    align-items: center;
  }
}
@media (min-width: 1024px) and (min-height: 1024px) and (orientation: landscape) {
  .image-onboarding-pretest-container {
    height: 188px;
    align-items: center;
  }
}
</style>
